import gql from "graphql-tag";

export const addVoucherM = gql`
    mutation AddVoucher(
        $beginDate: String!,
        $endDate: String!,
        $room: ID!,
        $client: ID!,
    ){
        addVoucher(
            beginDate: $beginDate,
            endDate: $endDate,
            room: $room,
            client: $client
        ) {
            _id
        }
    }
`;

export const updateVoucherM = gql`
    mutation UpdateVoucher(
        $_id: ID!,
        $beginDate: String!,
        $endDate: String!,
        $room: ID!,
        $client: ID!,
    ){
        updateVoucher(
            beginDate: $beginDate,
            endDate: $endDate,
            room: $room,
            client: $client
        ) {
            _id
        }
    }
`;

export const removeVoucherM = gql`
    mutation RemoveVoucher(
        $_id: ID!
    ){
        removeVoucher(
            _id: $_id
        ) {
            _id
        }
    }
`;


// WEBPACK FOOTER //
// ./src/graphql/mutation/voucher.js